var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSynthflowAiModel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "url(#synthflow-ai-model_svg__a)",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M25.664 19.859c.048 3.446-2.65 6.267-5.976 6.267l-3.686-.005c-1.188 0-2.15-.996-2.15-2.224s.964-2.224 2.153-2.224h3.642c.903 0 1.67-.676 1.707-1.656.036-.98-.725-1.789-1.666-1.789h-7.285c-3.28 0-6.017-2.691-6.067-6.08-.05-3.45 2.65-6.273 5.976-6.273h10.124c1.19 0 2.155.997 2.155 2.227s-.964 2.226-2.155 2.226H12.353c-.904 0-1.671.677-1.707 1.657s.725 1.789 1.665 1.789h7.281c3.283 0 6.025 2.693 6.072 6.085m-13.96 4.047c0 1.226-.961 2.22-2.148 2.22-1.186 0-2.148-.994-2.148-2.22s.962-2.22 2.148-2.22 2.148.994 2.148 2.22",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "synthflow-ai-model_svg__a",
  x1: 0,
  x2: 32,
  y1: 0,
  y2: 32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#140928"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#431890"
})))));
export { SvgSynthflowAiModel as ReactComponent };
export default __webpack_public_path__ + "assets/images/synthflow-ai-model.9a8fc2d2392a5bbff908fb62997567e8.svg";